import { useEffect,useState } from "react";
import Cookies from "universal-cookie";
import SpinnerPModal from "../modal/spinner";
import Toasts from "../toast";
import Icon from "../../Icons/general/Icon";
import VincularPantalla from "./vincularmodal";
import MainView from "./indexp1";
import Main2View from "./indexp2";
import { getVerficaPantalla } from "../../services/public/screen";

function ScreenView() {
    const [valida, setValida] = useState(false);
    const [spinner, setSpinner] = useState(false);
    const [tipollamado, setTipollamado] = useState(false);
    const [opciones, setOpciones] = useState([]);
    const [showToast, setShowToast] = useState(false);
    const [visualiza, setVisualiza] = useState(false);

    let cookies = new Cookies();

   //--------------------------------------------------------------------------------  
   const addParametros = async () => 
    {
      const Apk1 = cookies.get('ApkpI');
      const Apk2 = cookies.get('ApkpV');
    
      if (Apk1 && Apk2)
      {
        const PantallaId =  cookies.get('CtrpId');
        const response = await getVerficaPantalla(PantallaId, Apk1, Apk2);
        if (response)
          {
            if (response.status === 200) 
              {
                cookies.set('ApkpI',response.data.data[0].ClientAPKey, { path: "/",maxAge: 1000000 });
                cookies.set('ApkpV',response.data.data[0].CodigoVinc, { path: "/",maxAge: 1000000 });
                cookies.set('Ctrpar',response.data.data[0].AreaId, { path: "/",maxAge: 1000000 });
                cookies.set('CtrpId',response.data.data[0].PantallaId, { path: "/",maxAge: 1000000 });
                cookies.set('Ctrnpant',response.data.data[0].NombrePant, { path: "/",maxAge: 1000000 });
                cookies.set('Ctrprj',response.data.data[0].Proyecta, { path: "/",maxAge: 1000000 });
                cookies.set('CtrLvz',response.data.data[0].llamVoz, { path: "/",maxAge: 1000000 });
                setTipollamado(response.data.data[0].Tipollamado)
                setShowToast(false);
                setSpinner(true);
             }
           else
           {
             const Mensaje = response.message;
             const opc = { type: "Danger", message: Mensaje, active: true };
             setOpciones(opc);
             setShowToast(true);
             setValida(true);
           }
        }
        else
        {
          const Mensaje = response.message;
          const opc = { type: "Danger", message: Mensaje, active: true };
          setOpciones(opc);
          setShowToast(true);
          setValida(true);
        }
     }
     else
      {
         setValida(true);
      }
   };
  //----------------------------------------------------------------------------------    
  const handleArea = async(e) => 
    {
      setVisualiza(true);
    };
//---------------------------------------------------------------------------------

   useEffect(() => 
     {
      setVisualiza(false);
      addParametros();
      return () => 
        {
         
        }
     }, []);
      
  return (
      <>
        {valida && (
        <VincularPantalla
          show={valida}
          handleshow={setValida}
          handleparams={addParametros}
        ></VincularPantalla>
      )}
    {spinner && (<SpinnerPModal show={spinner} handleshow={setSpinner} handleAreas={handleArea}></SpinnerPModal>)} 

    {tipollamado === 1 &&
    (<MainView></MainView>)}

    {tipollamado === 2 &&
    (<Main2View></Main2View>)}
 </>
  );

}
export default ScreenView;
